import { useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";
import { trackPageView } from "@/lib/api/analytics.track.functions";

export function useTrackPageView() {
  const location = useLocation();
  const lastTracked = useRef<{ path: string; at: number } | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;

    const now = Date.now();
    if (lastTracked.current?.path === path && now - lastTracked.current.at < 1000) {
      return;
    }
    lastTracked.current = { path, at: now };

    void trackPageView({ data: { path } }).catch(() => {
      /* fire-and-forget */
    });
  }, [location.pathname]);
}
